<template>
 <div class="md-layout">

      <div class="md-layout-item md-xsmall-size-100 md-small-size-35 md-medium-size-25 md-large-size-20 md-xlarge-size-15">

    <md-card
      class="md-card-tabs"
      :class="[
      { 'flex-column': flexColumn },
      { 'nav-pills-icons': navPillsIcons },
      { 'md-card-plain': false }
    ]"
    >
        

          <md-card-content style="justify-content:center;">
            <md-list class="nav-tabs">
              <md-list-item
                v-for="(item, index) in tabName"
                @click="switchPanel(tabName[index])"
                :key="item + index"
                :class="[
            { active: isActivePanel(tabName[index]) },
            { [getTabColor(index)]: isActivePanel(tabName[index]) }
          ]"
              >
                {{ tabName[index] }}
                <md-icon v-if="navPillsIcons">{{ tabIcon[index] }}</md-icon>
              </md-list-item>
            </md-list>
                </md-card-content>
        </md-card>
      </div>
<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-75 md-large-size-80 md-xlarge-size-80 mx-auto">

        <transition name="fade" mode="out-in">
          <div class="tab-content">
            <template v-for="(item, index) in tabName">
              <template v-if="isActivePanel(tabName[index])">
                <div class="tab-pane" :class="getTabContent(index + 1)" :key="item + index">
                  <slot :name="getTabContent(index + 1)"></slot>
                </div>
              </template>
            </template>
          </div>
        </transition>
</div>
  </div>
</template>

<script>
export default {
  props: {
    flexColumn: Boolean,
    navPillsIcons: Boolean,
    plain: Boolean,
    tabName: Array,
    tabIcon: Array,
    tabColor: Array,
    colorButton: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activePanel: this.tabName[0]
    };
  },
  watch: {
    tabName(){
      this.activePanel = this.tabName[0];
    }
  },
  methods: {
    switchPanel(panel) {
      this.activePanel = panel;
    },
    isActivePanel(panel) {
      return this.activePanel == panel;
    },
    getTabColor: function(index) {
      return "md-" + this.tabColor[index] + "";
    },
    getColorButton: function(colorButton) {
      return "md-" + colorButton + "";
    },
    getTabContent: function(index) {
      return "tab-pane-" + index + "";
    }
  }
};
</script>

<style lang="css">
.menu-tabs {
  min-width: 225px;
  max-width: 225px;
}
</style>